import { NavLink, Outlet, useParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/ui";

const tabs = [
  { to: "users", label: "Users", end: false },
  { to: "sessions", label: "Sessions", end: false },
  { to: "schema", label: "Schema", end: false },
] as const;

export function AuthLayout() {
  const { id = "" } = useParams<{ id: string }>();

  return (
    <div>
      <PageHeader
        eyebrow="Auth"
        title="App-user auth"
        description="These are this project's frontend users, separate from platform owners. Browse them through owner APIs; project SQL gets auth.uid(), auth.role(), and a read-only auth.users projection. Secret hashes are never exposed."
      />
      <nav
        className="mb-5 flex flex-wrap gap-1 border-b border-border-standard pb-px"
        aria-label="Auth catalog sections"
      >
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={`/dashboard/projects/${id}/auth/${t.to}`}
            className={({ isActive }) =>
              cn(
                "rounded-t-md px-3 py-2 text-sm font-medium transition-colors duration-standard ease-standard",
                isActive
                  ? "border border-b-0 border-border-standard bg-surface-container-lowest text-text-primary"
                  : "text-text-muted hover:text-text-primary",
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
